module.exports = __webpack_public_path__ + "static/media/4_file_import_requirements_and_best_practices.4eb8e2b6.png";